import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { workflowService } from '../api/services';

export default function ListingFee({ onChange }) {
  const [plan, setPlan] = useState(null);
  const [error, setError] = useState('');
  const [accepted, setAccepted] = useState(false);
  const load = async () => {
    setError(''); setPlan(null); setAccepted(false); onChange(null);
    try { const data = await workflowService.settings(); setPlan(data); onChange({ ...data, accepted: Number(data.price) === 0 }); }
    catch { setError('Không tải được phí đăng tin. Vui lòng thử lại.'); }
  };
  // The parent setter is stable; load the quote once per editor session.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);
  return <section className="room-create-section listing-fee-panel">
    <h3>Phí & thời hạn tin đăng</h3>
    {error ? <p role="alert">{error} <button type="button" className="btn btn-neutral" onClick={load}>Thử lại</button></p> : !plan ? <p role="status">Đang tải bảng giá…</p> : <>
      <p><strong>{Number(plan.price).toLocaleString('vi-VN')} đ</strong> / {plan.duration_days} ngày · Số dư ví: <strong>{Number(plan.balance).toLocaleString('vi-VN')} đ</strong></p>
      <p>Tin hết hạn sẽ tự ngừng hiển thị. Gia hạn tại Phòng của tôi. Chỉnh sửa tin không thu phí.</p>
      <button type="button" className="btn btn-neutral" onClick={load}>Cập nhật bảng giá & số dư</button>
      {Number(plan.price) > 0 && <label className="amenity-checkbox"><input type="checkbox" checked={accepted} onChange={(event) => { setAccepted(event.target.checked); onChange({ ...plan, accepted: event.target.checked }); }} />Tôi đồng ý trừ {Number(plan.price).toLocaleString('vi-VN')} đ từ ví khi đăng thành công.</label>}
      {Number(plan.balance) < Number(plan.price) && <p role="alert">Số dư không đủ. <Link to="/wallet/top-up">Nạp tiền</Link></p>}
    </>}
  </section>;
}
